import { DESCRIPTION, INSURANCE_TYPE } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { schema } from "./validations";
import { routes } from "@/routes/utils";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Insurance Type",
    moduleRoute: `${routes.masterData}/${routes.insuranceType}`,
    schema,
    defaultValues: { [INSURANCE_TYPE]: "", [DESCRIPTION]: "" },
    nameFieldKey: INSURANCE_TYPE,
    queryKeyToInvalidate: "insurance-types",
    module: "insurance-types",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Insurance Type"
    />
  );
};

export default AddEdit;
